// const IS_LOCAL = false;
// export const API_URL = "https://maximal-backend.onrender.com";
// export const API_URL = "http://localhost:8001";
//  export const API_URL = "https://test0-01-599144898107.europe-west1.run.app";

export const API_URL = "https://maximal-master-backend.onrender.com";

// V1
// export const API_URL =
//   "https://maximal-cloud-services-599144898107.us-central1.run.app";

// V2
// export const API_URL = IS_LOCAL
//   ? "http://localhost:8001"
//   : "https://test0-01-599144898107.europe-west1.run.app";
